import { FormLabel, Grid, MenuItem, Select, TextField } from "@mui/material";
import { FORM_TYPE } from "../../helper/Constant";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

function GridForm({ type, column, attribute, titleForm, isRequired, handleChange }) {
    const dynamiAttribute = attribute;
    if (isRequired) {
        dynamiAttribute["required"] = true;
    }
    const GenerateForm = () => {
        if (type === FORM_TYPE.DATEPICKER) {
            return (
                <>
                    <br></br>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker {...dynamiAttribute} onChange={(e) => { handleChange(dynamiAttribute["name"], e) }}>
                        </DatePicker>
                    </LocalizationProvider>
                </>
            )
        }
        return (
            <TextField {...dynamiAttribute} onChange={(e) => { handleChange(e.target.name, e.target.value) }} fullWidth></TextField>
        )
    }
    return (
        <>
            <Grid sx={{ padding: "5px" }} xs={12} xl={column} lg={column} sm={12} md={column}>
                <FormLabel sx={[
                    {
                        color: "#000000",
                        fontWeight: "bold",
                        marginTop: "15px"
                    }, (isRequired) ?
                        {
                            "::after": {
                                content: '" *Wajib Diisi"', // Adds custom " (*)" after the label text
                                color: "red",      // Customize color
                                fontWeight: "bold", // Customize font weight
                                fontStyle: "italic"
                            }
                        } : {}
                ]}>{titleForm}</FormLabel>
                {GenerateForm()}
            </Grid>
        </>
    )
}
export default GridForm;